import { render, staticRenderFns } from "./activity-history-info.vue?vue&type=template&id=733d2840&scoped=true&"
import script from "./activity-history-info.vue?vue&type=script&lang=ts&"
export * from "./activity-history-info.vue?vue&type=script&lang=ts&"
import style0 from "./activity-history-info.vue?vue&type=style&index=0&id=733d2840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733d2840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
